import {TypeCPVClass} from './TypeCPVClass';
export class TypeObjCPV {

	public objetPrincipal: TypeCPVClass;

	public objetComplementaire: TypeCPVClass[];

	constructor() {
		 		this.objetPrincipal = new TypeCPVClass();
		this.objetComplementaire = [];

	}
}
